/**
 * Hand-mirrored shape of the `theaWebGuidePreviews/current` doc — a
 * BE-internal materialized doc (no shared-schema JSON), written by the hub
 * repo's scripts/materialize_guide_previews.py on a daily schedule and read
 * once per /gift-guides view. See GUIDE_PREVIEWS_MATERIALIZATION_SPEC.md in
 * the thea hub repo.
 *
 * Same doc-shape convention as materializedPeople.ts: server writes, client
 * reads, FE types mirrored by hand.
 */

export interface GuidePreviewsDoc {
  _schemaVersion: number;
  /** Firestore server timestamp of the last rebuild. */
  updatedAt?: unknown;
  /** thea-web master sha the guide→product map was extracted from. */
  builtFromSha?: string;
  /** listing key → final rendered image urls (already resolved
   *  mobile-cdn-first and compacted to GUIDE_BROWSE_TILE_COUNT by the
   *  writer — the FE renders these verbatim). */
  previews: Record<string, string[]>;
}

export const GUIDE_PREVIEWS_COLLECTION = 'theaWebGuidePreviews';
export const GUIDE_PREVIEWS_DOC_ID = 'current';
